import * as React from "react";
import type { BoxProps } from "../Box";
import { Box } from "../Box";

type CardProps = BoxProps & {
  children: React.ReactNode;
};

const Card = React.forwardRef<HTMLDivElement, CardProps>((props, ref) => {
  const { children, ...rest } = props;

  return (
    <Box
      ref={ref}
      background="card"
      borderRadius="standard"
      boxShadow="medium"
      {...rest}
    >
      {children}
    </Box>
  );
});

Card.displayName = "Card";

export type { CardProps };
export { Card };
